<div class="vcash-about-page" style="margin-bottom: 70px;">

  <!-- TOP HEADER -->
  <section class="vcash-top">
    <div class="vcash-appbar">
      <a class="appbar-btn" routerLink="/Profile">
        <img [src]="isAr ? '/assets/e-commerce/icons/60.webp' : '/assets/e-commerce/icons/61.webp'" alt="back" />
      </a>

      <h1 class="appbar-title">{{ "About Us" | transloco }}</h1>

      <div class="appbar-btn appbar-btn--ghost" routerLink="/notifications">
        <img src="/assets/e-commerce/icons/55.webp" alt="notifications" />
      </div>
    </div>
  </section>

  <!-- CONTENT -->
  <div class="vcash-content">

    <!-- SUMMARY CARD -->
    <section class="about-summary-card">
      <div class="about-summary-left">
        <span class="about-overline">{{ "welcome" | transloco }}</span>
        <h2>{{ "welcometext" | transloco }}</h2>
        <p>{{ "Discover more about our brand and what makes us special." | transloco }}</p>
      </div>

      <div class="about-summary-icon">
        <img src="/assets/e-commerce/icons/62.webp" alt="about" />
      </div>
    </section>

    <!-- MAIN ABOUT CARD -->
    <section class="about-main-card">
      <div class="about-hero">
        <img src="/assets/e-commerce/icons/90.webp" alt="about us" />
      </div>

      <h2 class="about-title">{{ "welcometext" | transloco }}</h2>

      <p class="about-body">
        {{ "aboutusbody" | transloco }}
      </p>
    </section>

  </div>
</div>